
import { Row, Col, Typography, Select } from "antd";

const { Text } = Typography;

const labelColProps = { flex: "164px" };
const contentColProps = { flex: "1 1 0", style: { minWidth: 0 } };
const controlWidthStyle = { width: 420, maxWidth: "100%" };
const ellipsisTextStyle = {
  display: "block",
  ...controlWidthStyle,
};

const CtaBrandRow = ({ cta, brands, brandValue, onBrandChange }) => {
  return (
    <>
      <Row
        gutter={[16, 16]}
        align="middle"
        wrap={false}
        style={{ marginTop: 12 }}
      >
        <Col {...labelColProps}>
          <Text>CTA:</Text>
        </Col>

        <Col {...contentColProps}>
          <Text
            ellipsis={{ tooltip: cta || "-" }}
            style={ellipsisTextStyle}
          >
            {cta || "-"}
          </Text>
        </Col>
      </Row>

      <Row
        gutter={[16, 16]}
        align="middle"
        wrap={false}
        style={{ marginTop: 12 }}
      >
        <Col {...labelColProps}>
          <Text>Client/Brand:</Text>
        </Col>

        <Col {...contentColProps}>
          <Select
            style={controlWidthStyle}
            value={brandValue || undefined}
            onChange={onBrandChange}
            options={brands}
            placeholder="Please select a brand"
            allowClear
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
          />
        </Col>
      </Row>
    </>
  );
};

export default CtaBrandRow;
